<template>
  <section class="c-step py-4 py-lg-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col col-12 col-md-6 mb-4 mb-md-0">
          <div class="c-result bg-white overflow-hidden br--small">
            <div class="c-result__banner p-3 p-lg-4">
              <div class="row align-items-center">
                <div class="col col-12 col-xl-5 mb-4 mb-xl-0 d-flex justify-content-center">
                  <div class="c-result__progress">
                    <div class="c-stadistic w-bold white">
                      <p class="fs-18 mb-1">Resultado:</p>
                      <p class="fs-30 mb-0">{{rightAnswers}}/{{exam.originalQuestions.length}}</p>
                    </div>
                    <svg class="c-result__percentage me-2">
                      <circle
                        cx="80"
                        cy="80"
                        r="79"
                        fill="none"
                        stroke-width="12px"
                        stroke-dasharray="500"
                        stroke-dashoffset="0"
                        stroke="#73af00"></circle>
                      <circle
                        cx="80"
                        cy="80"
                        r="79"
                        fill="none"
                        stroke-width="12px"
                        stroke-dasharray="500"
                        :stroke-dashoffset="500 - (500 * exam.score*100) / 100"
                        stroke="#fff"></circle>
                    </svg>
                  </div>
                </div>
                <div class="col col-12 col-xl-7 white text-center text-xl-left">
                  <h1 class="w-bold fs-21">¡No te rindas!</h1>
                  <p class="mb-0">
                    Necesitas acertar almenos
                    <span class="w-bold">{{exam.minimumForApprove}} preguntas</span> para aprobar.
                  </p>
                </div>
              </div>
            </div>
            <div
              class="d-flex flex-column align-items-center
                justify-content-center text-center p-3 py-4 p-lg-4 py-lg-5"
            >
              <transition name="fade" mode="out-in">
                <h2 class="fs-21 w-bold darks mb-2">
                  {{(nextTimeReady) ? '¿Listo para otra ronda?' : 'Te esperamos de vuelta'}}
                </h2>
              </transition>

              <transition name="fade" mode="out-in">
                <p v-if="!nextTimeReady" class="mb-4">
                  Vuelve a intentarlo en <span class="w-sbold fs-16">{{nextTimeLeft}} horas</span>
                </p>
                <p v-else class="mb-4">Demuestra de que estas hecho, ¡Ánimos!</p>
              </transition>

              <transition name="fade" mode="out-in">
                <router-link
                  v-if="!nextTimeReady && goBack"
                  :href="goBack"
                  class="c-button c-button--primary d-flex"
                >
                  <i class="iconf-left-arrow d-flex align-items-center me-2"></i>
                  Volver al curso
                </router-link>
                <button
                  v-else
                  class="c-button c-button--primary"
                  :class="{loading : isLoadingExam}"
                  :disabled="isLoadingExam"
                  @click="resetExam"
                >
                  {{(isLoadingExam) ? 'Creando examen...' : 'Empezar'}}
                  <img
                    class="c-button__spinner"
                    src="../../assets/images/animations/spinner-white.png" alt="loading"
                  />
                </button>
              </transition>
            </div>
          </div>
        </div>
        <div class="col col-12 col-md-6">
          <h2 class="w-bold fs-21 darks mb-3">Resumen</h2>
          <div class="c-summary">
            <ul class="ul-reset">
              <li
                v-for="(question, qindex) of exam.originalQuestions"
                :key="question.id"
                class="c-card-question p-3"
                :class="`c-card-question--${(question.right) ? 'right' : 'wrong'}`">
                <div class="me-2">
                  <div class="c-card-question__icon">
                    <i v-if="question.right" class="iconf-ok fs-18 d-flex align-items-center"></i>
                    <i v-else class="iconf-cancel fs-18 d-flex align-items-center"></i>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <p class="mb-0 w-medium">
                    <span class="w-bold">{{qindex + 1}}.</span> {{question.title}}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      isLoadingExam: false,
      intervalTimer: null,
    }
  },
  props: ['user', 'step', 'course', 'exam', 'goBack'],
  watch: {
    'exam.nextTime': function(value) {
      if(this.exam.nextTime <= 0)
        window.clearInterval(this.intervalTimer);
    },
  },
  computed: {
    rightAnswers: function() {
      return this.exam.originalQuestions.filter(q => q.right).length;
    },
    nextTimeLeft: function () {
      let seconds = Math.trunc(this.exam.nextTime % 60);
      let minutes = Math.trunc((this.exam.nextTime / 60) % 60);
      let hours   = (Math.trunc((this.exam.nextTime / 60) / 60)) % 60;

      if (this.exam.nextTime >= 0) {
        return `
          ${(hours >= 10) ? hours : '0' + hours} :
          ${(minutes >= 10) ? minutes : '0' + minutes} :
          ${(seconds >= 10) ? seconds : '0' + seconds}`;
      } else {
        return '00:00';
      }
    },
    nextTimeReady: function() {
      return (this.exam.nextTime <= 0) ? true : false;
    },
  },
  mounted() {
    this.initTimer();
  },
  methods: {
    initTimer: function() {
      if (this.exam.nextTime > 0) {
        this.intervalTimer = window.setInterval(() => {
          this.exam.nextTime--;
        }, 1000);
      }
    },
    resetExam: function() {
      this.isLoadingExam = true;

      const url = `${window.arcux.site}/api/v1/users/${this.user.id}/solved-exams/`;

      fetch(url,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.arcux.token}`,
        },
        body: JSON.stringify({
          examId: this.$route.params.exam_id,
          courseId: this.$route.params.course_id,
        }),
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.$emit('update:exam', data.data);
        this.$emit('update:step', 2);
      })
      .catch(err => {
        throw err;
      }).finally(() => {
        this.isLoadingExam = false;
      });
    },
  },
}
</script>
